import service from "@/utils/service";

/**
 * @Description:  登录
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/28 上午11:14
 */
export function loginByUsername(params) {
  return service.post("/self/login", params);
}

/**
 * @Description:  获取用户信息
 * @param:
 * @Author: ZhangBin
 * @Date 2019/3/28 下午1:47
 */
export function getInfoByUser(params) {
  return service({
    url: "/user",
    method: "get",
    params: params
  });
}

export function getUserFunction(params) {
  return service({
    url: "/menu/getMenuFunction",
    method: "get",
    params: params
  });
}

/**
 * @Description:  登出
 * @param:
 * @Author: ZhangBin
 * @Date 2018/4/4 下午1:44
 */
export function logout(params) {
  return service({
    url: "/logout",
    method: "get",
    params: params
  });
}

/**
 * @Description:  获取用户菜单
 * @param:
 * @Author: ZhangBin
 * @Date 2018/4/1 上午9:56
 */
export function getUserMenu(token) {
  return service({
    url: "/menu/userMenu",
    method: "get",
    params: token
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js